import React from 'react'
import { DataGrid } from '@/components/DataGrid/DataGrid'
import { DateTimeField, RecordField, TextField } from '@/shared/ui/Fields/Fields'
import { TestRunListResponseDTO, TestRunStatisticsItem } from '@/shared/api/gen/data-contracts'

const STATUS_COLORS: Record<string, string> = {
    WAITING: '#9E9E9E',
    SUCCESS: '#4CAF50',
    SKIPPED: '#607D8B',
    ERROR:   '#FF9800',
    FAILED:  '#F44336',
}

function StatsBadges({ statistics }: { statistics?: TestRunStatisticsItem[] }) {
    if (!statistics?.length) return <span className='text-14'>—</span>
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {statistics.map((item) => (
                <span
                    key={item.status}
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '4px',
                        padding: '2px 8px',
                        borderRadius: '12px',
                        backgroundColor: STATUS_COLORS[item.status as string] ?? '#9E9E9E',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 500,
                        whiteSpace: 'nowrap',
                    }}
                >
                    {item.status}: {item.count}
                </span>
            ))}
        </div>
    )
}

interface ITestRunDatagrid{
    data: TestRunListResponseDTO[],
    onRowClick: any,
    isActive: boolean
}

function TestRunsDatagrid({data, onRowClick, isActive}: ITestRunDatagrid) {
    const styles = isActive ? {borderRight: "black 1px solid"} : {}
    return (
        <DataGrid
            title="Тесты"
            records={data}
            style={{
                "width": isActive ? "20%" : "100%",
                minWidth: isActive ? "180px" : undefined,
                overflow: isActive ? "hidden" : undefined,
                ...styles
            }}
            rowProps={{
                "onClick": onRowClick,
            }}
        >
            <TextField key='id' label="ID" />
            {!isActive &&
                <RecordField
                    label='Версия'
                    render={(record: TestRunListResponseDTO) => (
                        <span className='text-14'>{record?.version || record?.branch || record?.commit || "—"}</span>
                    )}
                />
            }
            {!isActive &&
                <RecordField
                    label='Статистика'
                    render={(record: TestRunListResponseDTO) => (
                        <StatsBadges statistics={record?.statistics} />
                    )}
                />
            }
            {!isActive && <DateTimeField key="created_at" label="Дата создания теста" />}
        </DataGrid>
    )
}

export default TestRunsDatagrid;